import { BaseAPI } from '@/api/base.api';
import { MinioModel } from '@/services/minio.service';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

export class MinioAPI extends BaseAPI<any> {
  constructor() {
    super()
    this.apiUrl = `${this.apiUrl}/api/minio`;
  }

  public download(model: MinioModel): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/download`, model, {
      params: { 'attachment': true },
      responseType: 'blob'
    })
  }
}
